import React, {useEffect, useRef, useState} from 'react';

import {Loader} from 'components/Loader';

const normalizeIframeInfo = (iframeData) => {
    if (!iframeData) {
        return null;
    }

    if (typeof iframeData === 'string') {
        try {
            return JSON.parse(iframeData);
        } catch (error) {
            return null;
        }
    }

    return iframeData;
};

const buildVideoSrc = (iframeData) => {
    const normalizedIframeData = normalizeIframeInfo(iframeData);

    if (!normalizedIframeData || !normalizedIframeData.oid || !normalizedIframeData.idVal) {
        return '';
    }

    const params = new URLSearchParams({
        oid: normalizedIframeData.oid,
        id: normalizedIframeData.idVal
    });

    if (normalizedIframeData.hash) {
        params.set('hash', normalizedIframeData.hash);
    }

    return `https://vkvideo.ru/video_ext.php?${params.toString()}`;
};

export const VKVideoFrame = ({ iframeData, mb = 0 }) => {
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [loading, setLoading] = useState(true);
    const src = buildVideoSrc(iframeData);

    useEffect(() => {
        const updateSize = () => {
            if (!containerRef.current) {
                return;
            }

            const width = containerRef.current.offsetWidth;
            setDimensions({
                width,
                height: width ? width / 1.8 : 0
            });
        };

        updateSize();
        window.addEventListener('resize', updateSize);

        return () => {
            window.removeEventListener('resize', updateSize);
        };
    }, []);

    useEffect(() => {
        setLoading(true);
    }, [src]);

    if (!src) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            style={{
                width: '100%',
                position: 'relative',
                minHeight: dimensions.height || 220,
                marginBottom: mb
            }}>
            {loading ? (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: dimensions.height || 220,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(255,255,255,0.7)',
                        zIndex: 2,
                        borderRadius: 12
                    }}>
                    <Loader />
                </div>
            ) : null}

            <iframe
                src={src}
                width={dimensions.width || '100%'}
                height={dimensions.height || 220}
                allowFullScreen
                allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                style={{
                    border: 0,
                    borderRadius: 12,
                    width: '100%',
                    height: dimensions.height || 220,
                    display: loading ? 'none' : 'block'
                }}
                tabIndex={-1}
                title="video preview"
                onLoad={() => setLoading(false)}
            />
        </div>
    );
};
